import React, { useEffect, useState } from 'react';

const PHASES = [
  { id: "generating", label: "Generating", color: "#6366f1" },
  { id: "validation", label: "Validating", color: "#06b6d4" },
  { id: "fixing", label: "Polishing", color: "#f59e0b" },
  { id: "images", label: "Images", color: "#ec4899" },
  { id: "ready", label: "Ready", color: "#22c55e" },
];

export default function AgentProgressBar({ phase, isVisible }) {
  const [dots, setDots] = useState("");

  useEffect(() => {
    if (!isVisible || phase === "ready") return;
    const interval = setInterval(() => setDots(d => d.length >= 3 ? "" : d + "."), 400);
    return () => clearInterval(interval);
  }, [isVisible, phase]);

  if (!isVisible) return null;

  const current = PHASES.find(p => p.id === phase) || PHASES[0];
  const phaseIndex = PHASES.findIndex(p => p.id === phase);
  const progress = Math.round(((phaseIndex + 1) / PHASES.length) * 100);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8,
      padding: '4px 12px', borderRadius: 20,
      background: 'var(--bg-card, #1e293b)', border: '1px solid var(--border, #334155)',
      fontSize: 11, fontWeight: 600, color: current.color,
      animation: phase !== 'ready' ? 'agentFade 1.5s ease-in-out infinite' : 'none',
    }}>
      <div style={{
        width: 6, height: 6, borderRadius: '50%', background: current.color,
        boxShadow: `0 0 6px ${current.color}`,
      }} />
      <span style={{ color: 'var(--text-secondary, #94a3b8)' }}>
        {current.label}{phase !== "ready" ? dots : ""}
      </span>
      <div style={{ width: 40, height: 3, background: 'rgba(255,255,255,0.1)', borderRadius: 2, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${progress}%`, background: current.color, borderRadius: 2, transition: 'width 0.5s ease' }} />
      </div>
      <style>{`@keyframes agentFade { 0%,100% { opacity:1; } 50% { opacity:0.6; } }`}</style>
    </div>
  );
}
